// 1. 首先定义 JSON 数据的类型接口
interface LandingData {
  [key: string]: {
    main_tip: {
      all: string;
      other: string;
    };
    create_content: {
      title: {
        all: string;
        other: string;
      };
      sub_title: string;
    };
    callback: {
      normal: string;
      link: string;
    };
    suggest_title: string;
    fitChat: {
      title: string;
      header: string[];
      rows: Array<{
        shape: string;
        values: string[];
      }>;
      tips: string[];
    };
    label_data: {
      [key: string]: {
        steps: {
          [key: string]: string;
        };
        suggest: {
          well: {
            title: string;
            tips: string[];
          };
          avoid: {
            title: string;
            tips: string[];
          };
        };
        faq: {
          faqs: Array<{
            question: string;
            answer: string;
          }>;
        };
      };
    };
  };
}

// 2. 创建数据对象
export const landingData: LandingData = {
  'virtual-hair-color-try-on': {
    main_tip: {
      all: 'Trendiest Hairstyles That Look Great with Any Hair Color',
      other: 'Of The Most Flattering Hairstyles for ***'
    },
    create_content: {
      title: {
        all: 'How To Choose The Right Hair Color For You',
        other: 'How to Determine if *** Hair Color Is Right for You'
      },
      sub_title:
        "Take the guesswork out of choosing hair color — we'll guide you to shades that truly suit your tone, style, and vibe."
    },
    callback: {
      normal: "Can't decide on the right hair color? Let our *** show you your perfect shade—instantly!",
      link: 'AI hairstyle simulator'
    },
    suggest_title: "Styling Tips for *** Hair: Do's & Don'ts",
    fitChat: {
      title: 'Hair Color & Skin Tone Compatibility Chart',
      header: ['Hair Color ↓ / Skin Tone →', 'Fair Skin', 'Medium Skin', 'Dark Skin'],
      rows: [
        {
          shape: 'Blonde Hair',
          values: ['✅', '⭐', '⭐']
        },
        {
          shape: 'Brown Hair',
          values: ['✅', '✅', '✅']
        },
        {
          shape: 'Grey Hair',
          values: ['⭐', '⚠️', '✅']
        },
        {
          shape: 'Red Hair',
          values: ['⭐', '⭐', '✅']
        },
        {
          shape: 'Black Hair',
          values: ['✅', '✅', '✅']
        },
        {
          shape: 'White Hair',
          values: ['⭐', '⚠️', '⚠️']
        },
        {
          shape: 'Pink Hair',
          values: ['⭐', '⭐', '✅']
        },
        {
          shape: 'Purple Hair',
          values: ['⭐', '⭐', '✅']
        },
        {
          shape: 'Blue Hair',
          values: ['⭐', '⚠️', '✅']
        },
        {
          shape: 'Balayage',
          values: ['✅', '✅', '✅']
        }
      ],
      tips: [
        '✅ Best match: Very flattering for this skin tone',
        '⭐ Good choice: Works well with minor adjustments',
        '⚠️ Use with caution: May require styling to suit this face shape'
      ]
    },
    label_data: {
      All: {
        steps: {
          'Step 1':
            'Identify your skin tone and undertone—this helps narrow down shades that naturally complement your complexion.',
          'Step 2':
            'Think about your lifestyle—low-maintenance colors work better if you want less frequent salon visits.',
          'Step 3':
            'Choose a color that matches your personality or mood—bold for a change, subtle for a natural refresh.'
        },
        suggest: {
          well: {
            title: '✔️ Recommended',
            tips: [
              '🌊 Soft waves or natural textures let your hair shine without relying on color.',
              '✂️ Face-framing layers add dimension and flatter most tones and face shapes.',
              '💇‍♀️ Neutral styles like a classic bob or long layers suit a wide range of colors.',
              '✨ Glossy finishes enhance shine and make any base color feel polished.',
              '🌀 Half-up styles offer versatility without committing to a specific look.'
            ]
          },
          avoid: {
            title: '❌ Avoid',
            tips: [
              '🎨 Bold color-blocked cuts may look unfinished without a clear color plan.',
              '🪒 Extreme fades or sharp angles can limit how natural or subtle your color feels.',
              '🧪 Heavily styled looks that rely on color contrast may lack impact.',
              '🔧 High-maintenance textures can make subtle colors feel less noticeable.',
              '🧑‍🎤 Over-personalized styles tied to trends may not match your evolving preferences.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What hairstyle works well with any hair color?',
              answer:
                "Hairstyles like soft waves, classic bobs, and long layers are versatile and look great with any color. They allow you to experiment with different shades, whether you're going for blonde, brown, red, or even pastel hues."
            },
            {
              question: 'Can I try different hair colors without committing?',
              answer:
                'Yes! Temporary hair colors, like color sprays or chalks, let you try bold shades without long-term commitment. These are great for experimenting with colors like blue, pink, or purple before deciding on something permanent.'
            },
            {
              question: 'How do I choose a hair color for my hairstyle?',
              answer:
                'Use Hairpaca, an AI-powered hairstyle simulator, to quickly try out various hair colors without committing to a permanent dye. It lets you visualize how different shades will look with your current hairstyle, helping you make a more informed choice before any real dyeing!'
            },
            {
              question: "What's the best hair color for a medium-length haircut?",
              answer:
                'Medium-length cuts look great with rich tones like warm browns, auburns, or caramel highlights. These shades add depth and dimension to the hairstyle, making it versatile for both casual and more polished looks.'
            },
            {
              question: 'How do I know if bold hair colors will suit me?',
              answer:
                "Bold colors like vibrant red, blue, or pink can work for anyone, but it's important to consider your skin tone and overall style. Start with highlights or balayage for a subtle pop before fully committing to a bold shade."
            }
          ]
        }
      },
      Blonde: {
        steps: {
          'Step 1':
            'Consider your skin undertone. Blondes typically enhance cooler undertones; check if your skin has blue, pink, or neutral hues.',
          'Step 2':
            'Evaluate lifestyle maintenance. Blonde colors often require regular touch-ups and special care to keep them vibrant and healthy.',
          'Step 3':
            'Visualize yourself in blonde. Look at photos of celebrities with blonde hair to imagine the transformation on your features.'
        },
        suggest: {
          well: {
            title: 'Works Well for Blonde',
            tips: [
              '🌼 Opt for pastel hues in your clothing, like mint or baby blue, which complement blonde hair beautifully.',
              '🎨 Choose sun-kissed, golden highlights to enhance your natural blonde tones and give a bright glow.',
              '👗 Pair rich jewel tones with your blonde tresses to create an elegant and eye-catching look.',
              '🌷 Include soft coral tones in your wardrobe for a subtle contrast that highlights blonde hair.',
              '🧦 Select warm neutrals, such as beige or creamy whites, for a sophisticated and cohesive ensemble.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Blonde',
            tips: [
              '🔴 Steer clear of neons and bright reds, which can overshadow the delicate shades of blonde hair.',
              '🖤 Avoid solid black tops, as they can make blonde hair appear dull or washed out.',
              '⚔️ Stay away from earthy greens, like olive, which can clash with your golden locks.',
              '🔵 Skip deep navy outfits that might overpower your light blonde hair.',
              '🍋 Avoid overusing yellow in your wardrobe, as it can blend with blonde hair, making it less distinct.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What is the best blonde hair color for fair skin tones?',
              answer:
                "For fair skin, try ash blonde or platinum blonde shades. They blend well with light complexions, offering a stunning contrast without overwhelming the skin's undertone. Opt for these shades if you desire a sleek, eye-catching look."
            },
            {
              question: 'Can I dye my hair blonde without it turning brassy?',
              answer:
                'Avoid brassiness by using purple shampoo and investing in high-quality hair dye. Regularly maintain your color with toners designed for blonde hair. Consider consulting a professional for color applications and recommendations suited to your hair type.'
            },
            {
              question: 'Which blonde shades are best for a natural look?',
              answer:
                'For a natural look, honey blonde and caramel blonde are ideal. These warm, soft shades mimic natural highlights, adapt well to various base colors, and create a sun-kissed glow that looks effortless year-round.'
            },
            {
              question: 'How often should I touch up my blonde highlights?',
              answer:
                'Touch up blonde highlights every 6 to 8 weeks to maintain vibrancy and avoid roots showing. Scheduling regular salon visits ensures your color remains fresh and stunning. Use nourishing treatments to protect the hair between appointments.'
            },
            {
              question: 'What blonde hair trends are popular for 2023?',
              answer:
                'Barbie blonde is all the rage in 2023. Opt for solid or balayage styles that create depth and shimmer. Pair it with a chic haircut like a bob or waves. Follow trends for blonde hair innovations on social media platforms for more vibrant ideas.'
            }
          ]
        }
      },
      Balayage: {
        steps: {
          'Step 1':
            'Consider your natural hair color; Balayage works best with slightly lighter or darker shades for a seamless and natural look.',
          'Step 2':
            'Assess your lifestyle; if you prefer low maintenance, Balayage requires less frequent touch-ups than full-head coloring.',
          'Step 3':
            'Visualize yourself with subtle highlights; Balayage offers soft transitions and depth, perfect for enhancing natural beauty without drastic changes.'
        },
        suggest: {
          well: {
            title: 'Works Well for Balayage',
            tips: [
              '🎨 Opt for warm tones like honey blonde or caramel to complement curly balayage layers and enhance the best styles for Balayage.',
              '✨ Choose ash brown or soft mocha colors for a sleek, straight balayage that highlights the layers and gives depth.',
              '🌟 Embrace the sun-kissed look with golden highlights on feathered balayage cuts for a naturally radiant appearance.',
              '🖌️ Mix soft pink or lavender hues on textured waves for a playful, modern Balayage style.',
              '🌈 Bright copper tones can bring out the best in shaggy balayage and add vibrancy in straight and wavy textures.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Balayage',
            tips: [
              '🚫 Steer clear of harsh primary colors like bright red or blue on layered Balayage styles as they can overshadow the natural blend.',
              '❌ Dark jet black shades may conceal the subtle transition of Balayage blends, especially on curls or waves.',
              '🔴 Avoid bright neon tints on balayage bob cuts, as they can clash with the gradual dye effect.',
              '⛔ Refrain from using pure white highlights on textured Balayage, as they can create an unnatural contrast.',
              '⚠️ Strong burgundy tones might limit the dimension of straight Balayage styles and inhibit the depth effect.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What is balayage and how does it differ from traditional highlights?',
              answer:
                "Balayage is a hair coloring technique where the dye is painted on in a sweeping motion. It's different from traditional highlights as it creates a softer, more natural blend of colors, offering a sun-kissed effect without harsh lines."
            },
            {
              question: 'How can I choose the best balayage colors for my hair?',
              answer:
                'Selecting the best balayage colors depends on your skin tone, natural hair color, and desired look. Consulting a professional stylist can help you find shades that complement and enhance your features, ensuring a flawless transition.'
            },
            {
              question: 'Is balayage suitable for all hair types and lengths?',
              answer:
                "Balayage is versatile and can be adapted to suit most hair types and lengths, from short hair to long flowing locks. However, the effect varies based on your hair's texture and density, offering a personalized look for everyone."
            },
            {
              question: 'How long does balayage last compared to regular hair coloring?',
              answer:
                'Balayage is low-maintenance and can last up to 6-8 months. Unlike traditional coloring, it grows out softly, reducing the need for frequent touch-ups, making it ideal for busy lifestyles and those seeking a subtle change.'
            },
            {
              question: 'Can you balayage your hair at home, or is professional help recommended?',
              answer:
                "While at-home balayage kits exist, achieving optimal results can be challenging. Professional stylists ensure a precise application for seamless color blends. If you're aiming for a polished look, it's best to seek expert assistance."
            }
          ]
        }
      },
      Brown: {
        steps: {
          'Step 1':
            'Assess your skin tone: Brown shades complement warm, neutral, and cool undertones. Notice if golden, olive, or pink hues work with your complexion.',
          'Step 2':
            'Consider eye color enhancement: Brown hair elevates green, blue, and hazel eyes. Check if this color makes your eye color stand out.',
          'Step 3':
            'Reflect on your style: Brown is versatile and sophisticated. Think about if this color suits your personality and wardrobe choices.'
        },
        suggest: {
          well: {
            title: 'Works Well for Brown',
            tips: [
              '🧣 Pair your brown clothing with jewel-toned accessories for a chic contrast that uplifts your look elegantly.',
              '🧥 Opt for tailored cuts when selecting brown coats and jackets to ensure they add a polished finish to your ensemble.',
              "🟨 Incorporate mustard yellow into your brown outfit for a warm, inviting appearance that's perfect for autumn days.",
              '🟧 Choose textured fabrics like corduroy or wool in brown shades to add depth and interest to your casual outfits.',
              '🌿 Earthy tones paired with brown can create a harmoniously natural vibe, enhancing outdoor wear with subtle elegance.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Brown',
            tips: [
              "🚫 Steer clear of neon colors when wearing brown, as they can clash and overpower the earthy tones you're aiming for.",
              '🔸 Avoid overly frilled or ruffled brown dresses, which can detract from the sophistication of the color.',
              '🥶 Say no to overly cold or icy blues with brown styles, as they can make the outfit look washed out or dull.',
              '🔺 Skip red accessories with brown outfits, as they may create a harsh contrast not flattering to the eye.',
              '🌟 Resist the urge to blend too many brown shades together, which can look monotonous rather than stylish.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: How do I choose the right shade for a brown hairstyle?',
              answer:
                "A: Opt for a shade that complements your skin tone. Warm browns like caramel can brighten medium to olive skin, while cooler tones suit fair complexions. Always choose a color that enhances your hair's natural vibrancy and consider consulting a colorist."
            },
            {
              question: 'Q: Can I transition my colored hair to a natural brown shade?',
              answer:
                "A: Yes! To embrace a natural brown, start by selecting a shade close to your roots. Gradually blend the color with highlights or lowlights to reduce stark contrasts and preserve hair health. Use sulfate-free shampoos to maintain the color's richness."
            },
            {
              question: 'Q: What are trending brown hairstyles this season?',
              answer:
                'A: The top trends include balayage brown shades, chocolate brown bob cuts, and espresso brunette waves. Each offers versatility for styling and suits various hair textures beautifully. Ideal for those seeking subtle elegance and trendy color options.'
            },
            {
              question: 'Q: How can I maintain my brown hair color at home?',
              answer:
                'A: Maintain vibrancy by using a color-protecting shampoo and conditioner. Incorporate hydrating hair masks weekly to prevent dryness. Limit heat styling and sun exposure, and consider a cool water rinse to keep your chocolate brown or caramel tones bright.'
            },
            {
              question: 'Q: Is brown hair flattering for all face shapes?',
              answer:
                'A: Brown hair is universally flattering across face shapes. Oval faces can play with layers in chestnut or mahogany for depth, while round faces benefit from highlights around the face that create contours. Personalized cuts enhance natural features beautifully.'
            }
          ]
        }
      },
      Grey: {
        steps: {
          'Step 1':
            'Consider your skin tone: Grey hair complements cool, neutral skin tones best. Warmer tones may need contrasting makeup for balance.',
          'Step 2':
            'Evaluate lifestyle: Maintenance for grey tones requires commitment. Consider your daily routine and ease of upkeep.',
          'Step 3':
            'Imagine personal style: Grey hair can be bold or subtle. Picture the color with your wardrobe and overall look.'
        },
        suggest: {
          well: {
            title: 'Works Well for Grey',
            tips: [
              '🧥 Pairing grey with a tailored charcoal blazer creates a sophisticated, elegant look, ideal for formal occasions.',
              '🌧 A grey woolen scarf adds texture and warmth, making it the best accessory for casual winter wear.',
              '👖 Wearing a pair of slim-fit grey jeans enhances the stylish allure of monochrome outfits, perfect for everyday fashion.',
              '👔 Opt for light grey, soft cotton shirts to achieve understated vibrance in professional settings.',
              '🎩 Combining grey with textured tweed jackets brings out the richness in fall attire.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Grey',
            tips: [
              '🚫 Steer clear of oversized grey sweatpants that may look too casual and shapeless, focusing instead on best styles for Grey that fit well.',
              '🚫 Avoid pairing grey with neon-bright clothing items, as it might clash and diminish the subtle elegance of the color.',
              '🚫 Refrain from wearing grey polyester tops with shiny textures, as they might look outdated or less flattering.',
              '🚫 Stay away from dull, grey solid turtlenecks in overly tight cuts to avoid discomfort and lack of style.',
              "🚫 Skip grey synthetic shoes that don't complement the softness of your overall attire."
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are some trendy grey hairstyles for short hair?',
              answer:
                'A: Opt for a sleek bob with grey highlights or a pixie cut with silver accents. Both styles are fresh and easy to maintain, ideal for showcasing modern elegance. Searching “trendy grey hairstyles for short hair” can provide more inspiration.'
            },
            {
              question: 'Q: How do I choose the right shade of grey for my long hair?',
              answer:
                'A: Consider your skin tone and eye color when selecting grey shades. Cool skin tones pair well with silver or ash grey, while warmer tones look great with charcoal or slate grey. Look up “matching grey hair colors with skin tones” for more guidance.'
            },
            {
              question: 'Q: Can grey hair be vibrant and stylish?',
              answer:
                'A: Absolutely! Grey hair can be striking and full of personality with the right styling. Adding layers, curls, or blending hues like lavender or teal can enhance vibrancy. Explore “ways to style grey hair with color pops” for fresh ideas.'
            },
            {
              question: 'Q: How to care for dyed grey hair to maintain its shine?',
              answer:
                'A: Use sulfate-free shampoos and conditioners designed for color-treated hair to preserve shine. Regularly apply a purple-toning shampoo to avoid yellowing and boost brilliance. For more tips, search “care routine for dyed grey hair” online.'
            },
            {
              question: 'Q: What are grey hair color ideas for a natural look?',
              answer:
                'A: Try integrating grey balayage or ombre effects to subtly blend with natural tones, enhancing depth and a seamless transition. These techniques are excellent for creating authenticity. Explore “natural-looking grey hair colors” for further inspiration.'
            }
          ]
        }
      },
      Black: {
        steps: {
          'Step 1':
            'Assess your skin tone: If you have medium to dark skin tones, black hair enhances features and creates bold style statements.',
          'Step 2':
            'Consider your wardrobe: Black complements neutral and vibrant clothing, offering versatility and an elegant touch to your overall look.',
          'Step 3':
            'Think about maintenance: Black hair shows roots and fading more prominently, so regular upkeep is needed for a polished appearance.'
        },
        suggest: {
          well: {
            title: 'Works Well for Black',
            tips: [
              '🖤 Pair with shiny satin textures to create the best styles for Black outfits that demand attention.',
              '🌟 Incorporate metallic accents like gold or silver to add a luxurious touch to the sophistication of Black.',
              '🌼 Bright pastels, such as baby pink or mint green, add playful contrast and bring a fresh feel to Black attire.',
              '🔷 Deep jewel tones like emerald or sapphire enhance the richness and depth of the best styles for Black.',
              '✨ Use luminous ivory and nude shades to effortlessly highlight the elegance inherent in Black ensembles.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Black',
            tips: [
              '🚫 Stay away from dark brown hues as they may blend with, rather than enhance, Black textures.',
              '⚠️ Avoid pairing Black with neon colors as they can overwhelm and clash, detracting from the polish of your look.',
              '🔴 Refrain from very dark maroon and burgundy shades as they might make Black appear washed out.',
              '❌ Resist using overly chunky or coarse knit textures when styling with Black, as it might detract from its sleekness.',
              '🔄 Skip earthy tones like muddy greens or tan, as they can appear unbalanced against Black vibrant styles.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are popular hairstyles for Black hair types?',
              answer:
                'Some popular hairstyles for Black hair include box braids, twists, afros, and dreadlocks. Each style offers versatility and promotes hair health, catering to curly and coily textures. Learn how to care for Black hair to maintain these stunning looks.'
            },
            {
              question: 'How can I choose the best hair color for Black hair?',
              answer:
                'Consider your skin tone and personal style. Warm tones like burgundy or chestnut complement warmer skin, while cooler shades like blue-black suit cooler skin tones. Experiment with temporary options before committing.'
            },
            {
              question: 'Is coloring Black hair different from other hair types?',
              answer:
                "Yes, Black hair requires special care due to its unique structure. It's essential to use products designed for textured hair and follow experts' advice for safe coloring at home, ensuring healthy locks."
            },
            {
              question: 'What are some trendy hair colors for Black hair this year?',
              answer:
                'Popular trends include highlights in caramel, honey blonde, and ash gray. Vibrant options like purple or rose gold ombré create bold statements. Browse hair color trends to find inspiration for Black hairstyles.'
            },
            {
              question: 'How can I maintain vibrant colors on Black hair longer?',
              answer:
                'Use color-safe shampoos, deep conditioners, and avoid hot styling tools to prolong vibrancy. Regular trims prevent dullness from split ends, ensuring your Black hair color remains lively and fresh.'
            }
          ]
        }
      },
      Red: {
        steps: {
          'Step 1':
            'Consider your skin undertone. Red hair complements those with cool, neutral, and some warm undertones. Evaluate to see if it brightens your complexion.',
          'Step 2':
            "Check lifestyle compatibility. Red shades require maintenance; assess if you're ready for the upkeep needed to keep it vibrant.",
          'Step 3':
            'Visualize your style. Think about your wardrobe and personality; see if bold red fits your unique aesthetic and boosts your confidence.'
        },
        suggest: {
          well: {
            title: 'Works Well for Red',
            tips: [
              '🌟 Combine vibrant red with classic black pieces like tailored pants for a timeless look.',
              '🌟 Try red with neutral tones such as beige or gray for a balanced and sophisticated ensemble.',
              '🌟 Pairing red with a textured denim jacket can add a casual flair to your outfit.',
              '🌟 Use red accents, like a scarf or bag, to inject a pop of color without overwhelming the look.',
              '🌟 Opt for a monochromatic red outfit to create a bold and powerful fashion statement.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Red',
            tips: [
              '🚫 Steer clear of neon or overly bright colors against red to prevent clashing and visual overload.',
              '🚫 Avoid pairing red with oversized plaid patterns, which may create a distracting contrast.',
              '🚫 Stay away from combining red with ultra-shiny or sequined textures for daytime outfits.',
              '🚫 Refrain from mixing red with pastels as they can tone down the vibrant appeal of red.',
              '🚫 Skip wearing red with clashing prints like polka dots or florals, which can confuse the eye.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are popular red hair dye colors?',
              answer:
                'A: Vibrant red, copper red, and deep burgundy are popular choices for red hair dyes. These shades offer a striking appearance and can complement various skin tones. Use "best red hair dye shades" to discover your ideal hue.'
            },
            {
              question: 'Q: How do I maintain my vibrant red hair color?',
              answer:
                'A: To keep your red hair vibrant, use sulfate-free shampoos and conditioners, avoid excessive heat styling, and wash your hair with cool water. Consider "red hair color maintenance tips" for more ideas.'
            },
            {
              question: 'Q: Which red hair color suits fair skin best?',
              answer:
                'A: Fair skin often pairs beautifully with shades like strawberry blonde and light auburn. These tones add a subtle warmth without overpowering. Explore "red hair colors for fair skin" to find the perfect match.'
            },
            {
              question: 'Q: What is the best way to cover grey hair with red dye?',
              answer:
                'A: Semi-permanent red dyes work well for blending grey seamlessly while adding dimension. They offer rich color without committing to permanent changes. Search "covering grey hair with red dye tips" for more insights.'
            },
            {
              question: 'Q: Are natural options available for achieving red hair color?',
              answer:
                'A: Henna is a popular natural option for getting a rich red hair color. It\'s chemical-free and conditions hair while coloring. Searching "natural red hair color with henna" will guide you on application methods.'
            }
          ]
        }
      },
      White: {
        steps: {
          'Step 1':
            'Consider your skin tone: White hair complements cool undertones best. It adds vibrancy to pale, pinkish, or fair complexion.',
          'Step 2':
            'Visualize your wardrobe: If you favor blues, blacks, and jewel tones, white hair will enhance and harmonize with these color choices.',
          'Step 3':
            'Reflect on personal style: Love bold contrasts and enjoy standing out? White hair offers a striking, eye-catching look that makes a statement.'
        },
        suggest: {
          well: {
            title: '🌟 Works Well for White',
            tips: [
              '🌼 Pair crisp white textures with soft pastel accents, like light pink or baby blue, for a fresh, airy look. Best styles for White involve pastel pairings!',
              '🌈 Incorporate vibrant patterns featuring floral or geometric designs to add a pop to all-white ensembles. Perfect patterns for white maximize visual interest.',
              '👗 Opt for structured silhouettes such as tailored blazers or pencil skirts to bring sharp definition to white outfits. Best styles for white are classic cuts.',
              '🌟 Layer a sheer, flowing fabric over elegant white attire to introduce dimension and movement. Textures to try for white include ethereal sheers.',
              '🔹 Accessorize with metallic touches like silver or gold to break up the monotony of whites and add a modern edge. Best accessories for white elevate with shimmer.'
            ]
          },
          avoid: {
            title: '🚫 Avoid If You Have White',
            tips: [
              '🚫 Steer clear of pairing white bottoms with stark black tops unless aiming for a highly contrasting look—styles to avoid for White prefer smooth transitions.',
              '⚠️ Avoid entirely baggy outfits in all-white as they can lack structure and definition, making the look appear washed-out. Style mishaps in white often involve too-loose attire.',
              '🚫 Refrain from mixing too many shades of off-white together, which can result in a mismatched appearance instead of cohesive unity. Best styles for white require consisent hues.',
              '⚠️ Keep away from pairing white with overly dark textures like heavy knits in deep shades, which might swallow the vibrant brightness of white. White styling tips: balance with light fabrics.',
              '🚫 Skip accessorizing with muddy or dull tones that can diminish the clean appeal of white ensembles. Styles to avoid for white prioritize staying vibrant.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are the most popular white hairstyles for women?',
              answer:
                'Popular white hairstyles include sleek platinum bobs, snowy pixie cuts, and icy waves. These styles embrace the versatility of white hair, giving a fresh, modern appearance while maintaining elegance. Try adding light texture or volume for a trendy finish.'
            },
            {
              question: 'How can I rock a white hair color in a professional setting?',
              answer:
                'Wearing white hair professionally is all about confidence! Opt for clean, polished styles such as a slicked-back ponytail or an elegant updo. These styles showcase the pure hues of white while suiting a corporate environment.'
            },
            {
              question: 'Are there specific styling products for maintaining vibrant white hair?',
              answer:
                "Definitely! Use purple shampoo and conditioner to combat yellowish tones and keep your white hair vibrant. Consider a lightweight hair serum for added shine without weighing it down, maintaining your hairstyle's freshness every day."
            },
            {
              question: 'Can white hair color suit different skin tones?',
              answer:
                'Yes, white hair color can be flattering across various skin tones. Warmer undertones pair well with creamy white shades, while cooler undertones can enhance icy white colors. Consult a stylist to find the perfect shade that complements your complexion.'
            },
            {
              question: 'Is it possible to add dimensions to white hairstyles with highlights?',
              answer:
                'Absolutely! Adding soft gray or silver highlights can give depth and texture to white hair, creating a multi-dimensional effect. Consider babylights for a subtle transition or balayage for a more natural blend between the colors.'
            }
          ]
        }
      },
      Pink: {
        steps: {
          'Step 1':
            'Check your skin tone: Pink suits those with cooler undertones, fair or olive skin. It complements blue or green eyes beautifully.',
          'Step 2':
            'Consider your lifestyle: Bold pink hair can be playful and expressive, perfect for creative environments and casual settings.',
          'Step 3':
            'Review hair upkeep: They require commitment — routine touch-ups every 4-6 weeks to maintain vibrancy and avoid fading.'
        },
        suggest: {
          well: {
            title: 'Works Well for Pink',
            tips: [
              '✨ Pair with soft pastels or light neutrals for a harmonious look, perfect for casual occasions or elegant gatherings.',
              '🎀 Add lace textures or silky satin finishes to bring out the playful and delicate nature of pink in dresses or blouses.',
              '🌸 Opt for floral prints to enhance the vibrant charm of pink, making it ideal for summer outfits.',
              '🌌 Combine with dark shades like navy or charcoal to create a stunning contrast, perfect for evening ensembles.',
              '💎 Include metallic accessories, like silver or gold, for that extra sparkle, elevating any pink attire to the next level.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Pink',
            tips: [
              '🚫 Steer clear of neon or overly bold colors that can clash with pink, causing your outfit to look overwhelming.',
              '❌ Avoid pairing pink with similar bold prints, like large graphic patterns, which might steal attention from its subtle beauty.',
              '🛑 Refrain from mixing different textures like heavy denim or coarse wool when styling pink pieces, as they might not blend seamlessly.',
              '🔳 Skip pairing with stark black; it can sometimes weigh down the lively essence of pink in your ensemble.',
              '🌱 Stay away from earthy tones such as olive or khaki, which may not complement the fresh appeal of pink in your outfit.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: Can anyone rock a pink hairstyle?',
              answer:
                "A: Absolutely! Pink hairstyles are versatile and can flatter any skin tone. From rose gold highlights to deep magenta shades, there's a pink hue for every personality and style. Consult with a colorist to find your perfect pink match."
            },
            {
              question: 'Q: How do I maintain my pink hair color vibrancy?',
              answer:
                'A: Keeping pink hair vibrant involves using color-safe products and avoiding harsh shampoos. Opt for purple toning shampoos to minimize fading and maintain luminescent hair color longer. Routine touch-ups at the salon can also help keep the pink hues radiant.'
            },
            {
              question: 'Q: What are popular pink hairstyles for short hair?',
              answer:
                'A: Short hair shines with pink hues like pastel pixie cuts or vintage pink bob hairstyles. Adding subtle layers or texture can enhance the overall look. Consider ombré effects or pink balayage for more dimension in shorter styles, perfect for making a bold yet trendy statement.'
            },
            {
              question: 'Q: How can I safely transition from dark hair to pastel pink?',
              answer:
                "A: Transitioning requires patience, usually involving multiple sessions to lighten your hair first. Use professional salon services for pink hair color change to ensure hair health. Once lightened, pastel pink can be applied, often considered 'baby pink' or 'cotton candy pink' shades."
            },
            {
              question: 'Q: What pink hair coloring methods are best for someone who likes to change styles often?',
              answer:
                'A: Semi-permanent pink dyes and hair chalks are great for flexibility, allowing frequent changes without long-term commitment. Consider temporary pink hair sprays for instant, vibrant color. These methods are ideal for people who enjoy experimenting with varied shades regularly.'
            }
          ]
        }
      },
      Purple: {
        steps: {
          'Step 1':
            'Assess your personal style preferences: Do vibrant, bold colors resonate with your fashion choices and personality?',
          'Step 2':
            'Consider your skin tone: Is your complexion more suited to cooler, bright colors without clashing or standing out too sharply?',
          'Step 3':
            'Evaluate your lifestyle needs: Can you manage the maintenance of purple hair and love the attention that colorful hues attract?'
        },
        suggest: {
          well: {
            title: 'Works Well for Purple',
            tips: [
              '🟣 Go for A-line skirts: A-line cuts in purple create an elegant silhouette, enhancing flow and depth.',
              "💜 Opt for velvet textures: Velvet garments in purple offer a rich, luxurious feel that's visually captivating.",
              '🔮 Pair with neutral colors: Beige or grey complements purple beautifully, allowing it to stand out as a statement.',
              '🎨 Experiment with ombre effects: Ombre styles that fade from darker to lighter shades of purple add dimension and intrigue.',
              '💠 Choose drape-style dresses: Fabrics that drape elegantly in purple highlight a sophisticated, regal appearance.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Purple',
            tips: [
              '🚫 Avoid oversaturated accessories: Over-accessorizing with vibrant hues can overshadow the best styles for purple, causing clashes.',
              '⚠️ Steer clear of bulky textures: Heavily textured fabrics in purple might appear overwhelming, making styles look heavy.',
              "❌ Skip all-over prints: Dense prints may interfere with purple's natural allure, causing visual chaos.",
              '⛔ Avoid stark contrasts: Pairing purple with sharp, contrasting colors like bright red or yellow can be jarring and distracting.',
              '⏩ Dodge extremely loose fits: Baggy garments in purple may drown the vibrant tone, compromising shape and flair.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What hairstyles work best with purple hair color?',
              answer:
                'A: Purple hair complements versatile styles. Try elegant waves for a sophisticated look or a messy bun for casual chic. Layered bobs enhance color dimension, while braided styles highlight deep violet hues beautifully. Use hair care products catering to vibrant dyes to maintain your purple glow.'
            },
            {
              question: 'Q: How do I choose the right shade of purple for my hair type?',
              answer:
                'A: Determine your skin undertone first; cool undertones pair well with icy lilac shades, while warm skins glow with rich plum and amethyst hues. Consult with a stylist specializing in vibrant colors to tailor the perfect purple shade that suits your texture and lifestyle.'
            },
            {
              question: 'Q: Can I dye my hair purple at home?',
              answer:
                'A: Yes, but ensure you have the right tools and products. Prep your hair with clarifying shampoo and choose ammonia-free formulas to prevent damage. For long-lasting results, follow detailed DIY guides specifically for vibrant purple hair colors. Keeping your hair conditioned is key.'
            },
            {
              question: 'Q: How can I maintain the vibrancy of my purple hair color?',
              answer:
                'A: Opt for color-safe shampoos and conditioners, avoiding sulfates to reduce fading. Regular use of purple-toned masks maintains depth and shine. When styling, prioritize heat-protectant sprays to keep your purple hues luscious and vivid. Regular touch-ups are vital for lasting color.'
            },
            {
              question: 'Q: What are some trending purple hair color styles for 2023?',
              answer:
                'A: Explore bold options like galaxy-inspired purple ombre or jewel-toned balayage. Pastel hues are trending for subtlety lovers. For those seeking drama, midnight purple or deep ultraviolet are captivating choices. Stay updated with stylist blogs showcasing creative, purple-centric hairstyling for fresh ideas.'
            }
          ]
        }
      },
      Blue: {
        steps: {
          'Step 1':
            'Assess your personal style: Do bold and vibrant colors resonate with your personality and clothing choices? Blue hair reflects adventure and creativity.',
          'Step 2':
            'Check your skin tone: Blue shades typically pop against fair, cool skin tones but can be customized to suit warmer skin tones too.',
          'Step 3':
            "Consider your lifestyle: Blue hair requires regular upkeep. Ensure you're ready for maintenance to keep the color vivid and fresh."
        },
        suggest: {
          well: {
            title: 'Works Well for Blue',
            tips: [
              '🎨 Pairing deep blue with warm neutrals like beige or camel can create an elegant and balanced look.',
              '🧥 The best styles for blue include fitted silhouettes in rich textures like velvet and suede for added depth.',
              '👗 A-line dresses in blue shades complement most body types and offer a timeless, versatile appearance.',
              '👜 Metallic accessories, especially in silver or gold, tend to enhance blue tones without overwhelming the outfit.',
              '👖 High-waisted pants in shades of blue work beautifully with tucked or cropped tops for a chic and polished ensemble.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Blue',
            tips: [
              '🚫 Avoid pastel blue for oversized styles; it can appear washed out and lose shape.',
              '🚫 Pairing navy blue with black in the same outfit often results in a muddled appearance rather than a sophisticated look.',
              '🚫 Shiny textures in blue, like satin or polyester, may reflect light poorly under certain conditions creating unwanted glare.',
              "🚫 Heavy embellishments on blue fabrics can look overly busy and distract from the color's inherent elegance.",
              '🚫 Combining multiple shades of blue in one outfit can clash, rather than complement, if not coordinated carefully.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are some popular blue hair dye brands?',
              answer:
                'A: Popular blue hair dye brands include Manic Panic, Arctic Fox, and Splat. These brands offer vibrant shades and semi-permanent formulas that are vegan and cruelty-free, perfect for achieving bold blue hair color safely at home.'
            },
            {
              question: 'Q: How can I maintain the vibrancy of blue hair color?',
              answer:
                'A: To keep blue hair bright, use color-safe shampoo and conditioner. Wash your hair with cool water and avoid prolonged sun exposure. Consider using leave-in treatments specifically designed for dyed hair to preserve your blue hairstyle.'
            },
            {
              question: 'Q: What hairstyles complement blue-colored hair?',
              answer:
                'A: Blue hair looks great with layered cuts, such as bob hairstyles or shoulder-length waves, which showcase the depth of the color. Experiment with braids or updos to highlight your bold hair color in different styles.'
            },
            {
              question: 'Q: Can I dye my hair blue without bleach?',
              answer:
                "A: It's possible to achieve dark blue shades without bleach if your hair is naturally light. Pick semi-permanent dyes tailored for darker natural hair tones, or consult a stylist for professional advice on embracing a blue color safely."
            },
            {
              question: 'Q: What temporary options are available for trying blue hair color?',
              answer:
                'A: Temporary blue hair color options include hair chalk, colored hair sprays, and clip-in extensions. These methods allow you to experiment with blue shades without a long-term commitment, perfect for events or trying a new look.'
            }
          ]
        }
      }
    }
  },
  'hair-types': {
    main_tip: {
      all: 'Trendiest Hairstyles That Best Suit Your Hair Type',
      other: 'Of The Most Flattering Hairstyles for *** Hair'
    },
    create_content: {
      title: {
        all: 'How to Figure Out Your Hair type',
        other: 'How To Determine If You Have  *** Hair'
      },
      sub_title: 'Discover styles that bring out the best in your natural texture by understanding your hair type'
    },
    callback: {
      normal: 'Now that you know your hair type, ***',
      link: 'explore the best hairstyles with Hairpaca Now!'
    },
    suggest_title: "Styling Tips for *** : Do's & Don'ts",
    fitChat: {
      title: 'Hair Type & Styling Recommendation',
      header: ['Hair Length ↓ / Face Shape →', 'Sleek & Straight', 'Beachy Waves', 'Voluminous Curls'],
      rows: [
        {
          shape: 'Straight Hair',
          values: ['✅', '⭐', '⚠️']
        },
        {
          shape: 'Wavy Hair',
          values: ['⭐', '✅', '⚠️']
        },
        {
          shape: 'Curly Hair',
          values: ['⚠️', '⭐', '✅']
        },
        {
          shape: 'Thin Hair',
          values: ['✅', '⭐', '⚠️']
        },
        {
          shape: 'Thick Hair',
          values: ['⭐', '✅', '✅']
        }
      ],
      tips: [
        '✅ Best match: Very flattering for this hair type',
        '⭐ Good choice: Works well with minor adjustments',
        '⚠️ Use with caution: May require styling to suit this hair type'
      ]
    },
    label_data: {
      All: {
        steps: {
          'Step 1':
            'Wash and dry your hair with no product. Use a full-length strand, ideally from the root, for an accurate comparison.',
          'Step 2': 'Place a regular sewing thread (about 6 inches) next to your hair strand on a flat surface.',
          'Step 3':
            "Compare thickness—if your hair is thinner, it's fine; similar, it's medium; thicker than the thread, it's coarse."
        },
        suggest: {
          well: {
            title: '✔️ Recommended',
            tips: [
              '💇‍♀️ Straight Hair: Blunt bobs or sleek lobs are among the best styles for straight hair—they add weight and polish.',
              '🌊 Wavy Hair: Long layers enhance natural bends and prevent bulk at the ends, great for bringing out waves.',
              '🌀 Curly Hair: A rounded shape cut helps curls fall naturally and look balanced all around.',
              '🌺 Coily Hair: Twist-outs and protective styles like flat twists or bantu knots define coils and protect ends.',
              '✂️ Straight Hair: Avoid excessive layering—it can make straight hair look thin and stringy.'
            ]
          },
          avoid: {
            title: '❌ Avoid',
            tips: [
              '✂️ Straight Hair: Avoid excessive layering—it can make straight hair look thin and stringy.',
              '🚫 Wavy Hair: Skip razor cuts or thinning shears—they can create frizz and uneven wave patterns.',
              '⚠️ Curly Hair: Avoid dry cutting curls when straightened—it may lead to uneven length when curls spring back.',
              '🔥 Coily Hair: Say no to daily heat styling—tight coils are more prone to heat damage and breakage.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What hairstyle is best for thick, curly hair?',
              answer:
                'Layered cuts and shoulder-length styles work best for thick, curly hair. They reduce bulk and define curls without frizz, helping you manage volume naturally.'
            },
            {
              question: 'Which hairstyles suit fine, straight hair best?',
              answer:
                'Blunt bobs and textured pixies are perfect for fine, straight hair. They create fullness and shape while keeping your style easy to manage and fresh.'
            },
            {
              question: 'Can I wear bangs with wavy hair?',
              answer:
                'Absolutely! Curtain bangs or long side-swept bangs pair beautifully with wavy hair, blending effortlessly and enhancing natural texture without extra styling.'
            },
            {
              question: "What's the ideal haircut for oily hair types?",
              answer:
                'Short to medium-length layered cuts help reduce oil build-up and keep hair looking fresh longer. Avoid heavy bangs, which can get greasy quickly.'
            },
            {
              question: 'How do I choose a hairstyle based on my hair type?',
              answer:
                "Start by identifying your hair type—straight, wavy, curly, or coily. Then look for styles that complement its texture, volume, and manageability to highlight your hair's natural beauty."
            },
            {
              question: 'Can I wear bangs with wavy hair?',
              answer:
                'Absolutely! Curtain bangs or long side-swept bangs pair beautifully with wavy hair, blending effortlessly and enhancing natural texture without extra styling.'
            },
            {
              question: "What's the ideal haircut for oily hair types?",
              answer:
                'Short to medium-length layered cuts help reduce oil build-up and keep hair looking fresh longer. Avoid heavy bangs, which can get greasy quickly.'
            },
            {
              question: 'How do I choose a hairstyle based on my hair type?',
              answer:
                "Start by identifying your hair type—straight, wavy, curly, or coily. Then look for styles that complement its texture, volume, and manageability to highlight your hair's natural beauty."
            }
          ]
        }
      },
      Curly: {
        steps: {
          'Step 1': 'Straight: Observe if your hair is completely flat with no waves or curls.',
          'Step 2': "Wavy: Look for gentle curves forming loose 'S' shapes from roots to ends.",
          'Step 3': 'Curly: Identify defined, springy curls forming circular or looped patterns.'
        },
        suggest: {
          well: {
            title: 'Works Well for Curly',
            tips: [
              '💇‍♀️ Embrace layers to add movement, one of the best styles for curly hair.',
              '🌀 Keep your curls hydrated with light creams for lush, defined ringlets.',
              '🌿 Opt for air-drying to enhance natural curl texture beautifully.',
              '🤹‍♀️ Scrunch with mousse for volume; a popular style for curly hair.',
              '🍃 Use a silk pillowcase for preserving curls overnight without frizz.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Curly',
            tips: [
              '💨 Skip blow-drying to avoid frizz, a common problem with curly styles.',
              '🔪 Avoid blunt cuts that can make curls look bulky and heavy.',
              '🌧 Say no to heavy gels that weigh down curls, limiting bounce.',
              '🚫Avoid daily shampoos that dehydrate curls, leading to brittle texture.',
              "🐑 Don't brush dry curls to prevent damage and loss of curl definition."
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: "What's the best hairstyle for curly hair?",
              answer:
                "For curly hair, layered cuts or long bob styles work wonders. They enhance your curls' natural bounce and help prevent excessive frizz. For added definition, consider using styling products tailored for curly types."
            },
            {
              question: 'How can I define my natural curly hair type?',
              answer:
                'To define curly hair types, consider the curl type ranging from 2A to 4C. Type indicators help in understanding hair moisture needs and selecting suitable products. Consult a curly hair chart for accurate identification.'
            },
            {
              question: 'What products should I use for healthy curly hair?',
              answer:
                'Use sulfate-free shampoos, hydrating conditioners, and curl creams for best curl retention. Products with aloe vera or shea butter are ideal for moisture and definition, ensuring your curls stay vibrant and well-nourished.'
            },
            {
              question: 'How can I prevent frizz in curly hair?',
              answer:
                'To combat frizz in curly hair, apply an anti-frizz serum or leave-in conditioner when damp. Use a microfiber towel to gently dry hair, reducing friction and frizz. Avoid alcohol-based styling products that can dry out curls.'
            },
            {
              question: 'How often should I wash curly hair?',
              answer:
                'Wash curly hair every 3-7 days, depending on your curl texture and scalp oiliness. Less frequent washing retains natural oils, essential for hydration and healthy curl pattern maintenance. Choose hydrating or co-wash alternatives.'
            }
          ]
        }
      },
      Thin: {
        steps: {
          'Step 1': 'Run fingers through your hair; observe if the texture feels straight, wavy, or curly.',
          'Step 2': "Look at hair in natural light; notice any waviness, curls, or the hair's overall straightness.",
          'Step 3':
            'Style your hair without products; check if it maintains its form or reverts to its natural shape quickly.'
        },
        suggest: {
          well: {
            title: 'Works Well for Thin',
            tips: [
              '💫 Embrace layered bob styles for an illusion of fuller hair.',
              '🌟 Opt for pixie cuts to add volume and sprightliness.',
              '✨ Try textured waves for added bounce and movement.',
              '🌼 Choose blunt bangs for a chic and fuller appearance.',
              '🍃 Explore asymmetrical cuts to amplify dimension and style.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Thin',
            tips: [
              '🚫 Say no to long, straight styles that weigh hair down.',
              '❌ Avoid heavy, thick bangs for a less bulky look.',
              '🔄 Steer clear of excessive flat ironing that removes natural volume.',
              '✂︎ Skip overly layered cuts which can weaken hair structure.',
              '🌑 Resist spiky styles that can expose thinness and scalp.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: How can I add volume to thin hair types?',
              answer:
                'A: Thin hair often struggles with volume, but a layered hairstyle can create an illusion of thickness. Use volumizing shampoos and blow-dry with a round brush for extra lift.'
            },
            {
              question: 'Q: What hairstyles best suit straight, thin hair?',
              answer:
                'A: Sleek bobs or pixie cuts work well with straight, thin hair. Try adding subtle waves or highlights to enhance depth and dimension.'
            },
            {
              question: 'Q: Can thin hair be styled into curls without damage?',
              answer:
                'A: Absolutely! Use heat protectant sprays and a curling iron on low settings. For a natural look, consider using foam rollers or braiding while damp.'
            },
            {
              question: 'Q: Which haircut is ideal for maintaining healthy thin hair?',
              answer:
                'A: For thin hair health, regular trims are crucial. Opt for gentle styles like a lob or step-cut that minimize tension at the roots and ends.'
            },
            {
              question: 'Q: What products help hydrate and nourish thin hair?',
              answer:
                'A: Lightweight leave-in conditioners and sulfate-free shampoos are excellent for thin hair. Look for products containing biotin and keratin to strengthen and moisturize.'
            }
          ]
        }
      },
      Wavy: {
        steps: {
          'Step 1': 'Gently tug a lock of hair and observe its shape. Is it straight, wavy, curly, or coily?',
          'Step 2': 'Examine thickness of individual strands for fine, medium, or coarse texture.',
          'Step 3': 'Assess hair volume by checking scalp coverage. Is it dense, average, or sparse?'
        },
        suggest: {
          well: {
            title: 'Works Well for Wavy',
            tips: [
              "💁‍♀️ Try layered cuts to enhance natural waves' bounce and movement.",
              '🌊 Embrace beach waves for a relaxed, effortless look with added texture.',
              '✂️ Opt for shoulder-length bob to define waves without weighing them down.',
              '✨ Use curling cream to accentuate waves and create a defined, polished style.',
              '🌀 Choose a side part to give waves a voluminous, chic appearance.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Wavy',
            tips: [
              '🚫 Steer clear of heavy straightening; it flattens the natural wavy texture.',
              '❌ Avoid blunt cuts as they can make waves appear uneven and unkempt.',
              '🌪️ Say no to excessive layering that might create a frizzy, unruly look.',
              '⚠️ Avoid pixie cuts; they might not showcase the best styles for wavy hair.',
              '🔄 Refrain from tight curls; they often clash with natural wave patterns.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'How can I enhance natural wavy hair?',
              answer:
                'Embrace your waves by using a lightweight hair mousse or curl-enhancing cream. Scrunch your damp hair gently for more defined waves. Also, avoid using too much heat to keep your hair healthy.'
            },
            {
              question: 'What are the best haircuts for wavy hair?',
              answer:
                'Consider layered cuts to add movement and reduce bulk, or long bobs for a trendy look. Soft bangs can frame your face, enhancing your natural waves without weighing them down.'
            },
            {
              question: 'Can I make my wavy hair curlier?',
              answer:
                'Absolutely! Apply a curl-enhancing gel or mousse and diffuse with a blow dryer to intensify your waves. Twisting sections of hair while damp can also promote tighter curls.'
            },
            {
              question: 'How do I prevent frizz in wavy hair?',
              answer:
                'Use a sulfate-free shampoo to prevent dryness, and a leave-in conditioner to retain moisture. Avoid brushing when dry; use a wide-tooth comb on damp hair to keep frizz at bay.'
            },
            {
              question: "What's the best styling technique for wavy hair?",
              answer:
                'Plopping is a great technique. After showering, apply a defining product, wrap hair in a T-shirt or microfiber towel for 15 minutes, then air dry. This enhances waves without damaging them.'
            }
          ]
        }
      },
      Thick: {
        steps: {
          'Step 1': 'Examine the thickness and coarseness of individual hair strands between your fingers.',
          'Step 2': 'Observe the natural curl pattern by letting your hair air dry naturally.',
          'Step 3': 'Assess overall volume and shine; some types are naturally shinier and have more bounce.'
        },
        suggest: {
          well: {
            title: 'Works Well for Thick',
            tips: [
              '💁‍♀️ Layers add movement and reduce bulk, optimizing best styles for Thick.',
              '🌀 Textured waves give volume control, enhancing best styles for Thick hair.',
              '✂️ Blunt cuts offer definition, refining best styles for Thick without excess.',
              '🌿 Natural curls embrace fullness, perfecting best styles for thick, curly hair.',
              '🔗 Braids hold structure, showcasing best styles for Thick during active days.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Thick',
            tips: [
              '🚫 Over-straightening can create dryness, styles to avoid for Thick hair.',
              '⛔️ Excessive layering might add volume, styles to avoid for Thick.',
              '❌ Close-cropped cuts can amplify weight, styles to avoid for Thick texture.',
              '🔍 Thin bangs might be hard to manage, styles to avoid for thick.',
              '💨 Voluminous blowouts increase bulk, styles to avoid for Thick.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: How do I choose the best hairstyle for thick hair?',
              answer:
                'A: The best hairstyle for thick hair depends on your face shape and lifestyle. Long layers can reduce bulk, while a bob is superb for versatility. Consider cuts that enhance texture for easier styling and healthier hair care.'
            },
            {
              question: 'Q: What are effective ways to manage thick curly hair daily?',
              answer:
                'A: For thick curly hair, use a wide-tooth comb and curl-defining products. Invest in quality leave-in conditioners and moisturize regularly. Opting for protective styles like braids helps maintain hydration and manageability.'
            },
            {
              question: 'Q: Which haircuts help reduce weight from thick, heavy hair?',
              answer:
                "A: Shag or layered cuts work wonders for thick hair. They lighten the load and add dimension. These styles offer movement and flexibility, and they're brilliant if you're seeking less styling time and weight."
            },
            {
              question: 'Q: How do I prevent frizz on thick hair in humid weather?',
              answer:
                'A: Combat frizz on thick hair by using anti-frizz products containing silicones or oils. Always dry hair thoroughly before heading out. Finish with a light mist of anti-humidity spray for smooth, shiny locks.'
            },
            {
              question: 'Q: What are some styling tips for thick straight hair?',
              answer:
                'A: To style thick straight hair, opt for volumizing mousse and avoid overusing heavy products. Try blow-drying with a paddle brush for a sleek finish, or use a flat iron for chic, polished looks on busy days.'
            }
          ]
        }
      },
      Straight: {
        steps: {
          'Step 1':
            'Examine hair texture when wet: Straight stays straight, wavy forms loose waves, curly creates spirals, coily coils tightly.',
          'Step 2':
            'Observe hair volume: Thin hair connects directly to scalp, thick has visible movement or frizz, and medium sits in between.',
          'Step 3':
            'Notice hair shape: Look for curvatures in your strands under natural lighting to determine straight, wavy, curly, or coily patterns. '
        },
        suggest: {
          well: {
            title: 'Works Well for Straight',
            tips: [
              '✨ Tame frizz with a sleek, long bob cut for best styles for Straight.',
              '💁 Enhance the shine with a blunt, shoulder-length cut for straight hair types.',
              '🌿 Add subtle waves for volume using a gentle texturizing spray on straight hair.',
              '🌟 Go for a pixie cut with wispy ends to highlight straight texture.',
              '🎨 Experiment with ombre color for a dimensional look perfect for straight styles.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Straight',
            tips: [
              '🚫 Skip heavy layering; it can weigh down straight hair, reducing volume and bounce.',
              '❌ Avoid tight ringlet perms as they clash with natural straight texture.',
              '🪥 Excessive use of matte products can dull the natural shine of straight hair.',
              '🔒 Say no to overly teased styles as they can damage finer straight textures.',
              '🌪 Avoid choppy cuts; they might make straight hair look sparse and unruly.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are the best haircuts for straight hair to add volume?',
              answer:
                "To add volume to straight hair, opt for layered haircuts or a textured bob. These styles cut through the heaviness and introduce movement, ensuring your straight hair doesn't fall flat. Consider incorporating bangs for a playful touch that adds balance."
            },
            {
              question: 'How can I maintain shine in straight hair naturally?',
              answer:
                'Natural oils like argan or coconut oil can help maintain shine in straight hair. Apply a few drops to damp hair and distribute evenly. Additionally, using a sulfate-free shampoo can keep your hair gleaming and healthy. Promote shine with a cold-water rinse after washing.'
            },
            {
              question: 'What is the best way to style straight hair without heat?',
              answer:
                'Create waves in straight hair without heat by braiding damp hair overnight or using hair rollers. For a chic look, try a sleek ponytail or braid for school or work. Anti-frizz products can help maintain a polished appearance, especially on humid days.'
            },
            {
              question: 'How do I prevent my straight hair from becoming oily quickly?',
              answer:
                'To tackle oily straight hair, opt for a lightweight dry shampoo between washes to absorb excess oil. Maintain a balanced washing routine with a clarifying shampoo once a week. Avoid heavy conditioners and products that can weigh hair down.'
            },
            {
              question: 'Are there specific products for styling fine, straight hair?',
              answer:
                'For fine, straight hair, use volumizing mousses or root-lifting sprays that add texture without overwhelming it. Opt for lightweight serums to define ends without adding extra weight. Fine-haired folks can benefit from hybrid products for both humidity control and shine.'
            }
          ]
        }
      }
    }
  },
  'best-hairstyles-for-face-shape': {
    main_tip: {
      all: 'Hairstyles That Best Suit Your Face Shape',
      other: 'Of The Most Flattering Hairstyles for ***'
    },
    create_content: {
      title: {
        all: 'How to Figure Out Your Face Shape',
        other: 'How To Determine If You Have a ***'
      },
      sub_title: 'Discover your perfect hairstyle by identifying your face shape'
    },
    callback: {
      normal: "Now that you've identified your face shape, ***",
      link: 'explore the best hairstyles with Hairpaca Now!'
    },
    suggest_title: "Styling Tips for *** : Do's & Don'ts",
    fitChat: {
      title: 'Face Shape & Hair Length Compatibility Chart',
      header: ['Face Shape ↓ / Hair Length →', 'Short', 'Medium', 'Long'],
      rows: [
        {
          shape: 'Round',
          values: ['✅', '⭐', '⚠️']
        },
        {
          shape: 'Oval',
          values: ['✅', '✅', '✅']
        },
        {
          shape: 'Square',
          values: ['⚠️', '⭐', '✅']
        },
        {
          shape: 'Heart',
          values: ['✅', '✅', '⚠️']
        },
        {
          shape: 'Long',
          values: ['⚠️', '⭐', '⚠️']
        }
      ],
      tips: [
        '✅ Best match: Very flattering for this face shape',
        '⭐ Good choice: Works well with minor adjustments',
        '⚠️ Use with caution: May require styling to suit this face shape'
      ]
    },
    label_data: {
      All: {
        steps: {
          'Step 1': 'Pull your hair back and take a clear front-facing photo in natural light.',
          'Step 2': 'Trace the outline of your face—focus on forehead width, cheekbones, jawline, and chin length.',
          'Step 3':
            'Compare the shape to common face types like oval, round, square, heart, or long to find your best match.'
        },
        suggest: {
          well: {
            title: ' ✔️ Recommended',
            tips: [
              '✂️ Long layers flatter most face shapes and add movement.',
              '🌊 Soft waves add volume and soften angular features.',
              '💇‍♀️ Blunt bobs work well for nearly any face shape, adding structure.',
              '🌀 Loose curls give a balanced look and frame the face nicely.',
              '✨ Side-swept bangs are versatile and suit many face shapes.'
            ]
          },
          avoid: {
            title: '❌ Avoid',
            tips: [
              '🎭 Super short pixie cuts may emphasize sharp angles or a narrow jaw.',
              '🧑‍🎤 Straight-across bangs can overwhelm rounded or long faces.',
              '🧪 Extremely tight curls may add bulk to already fuller faces.',
              '🪒 Sharp, geometric cuts may not suit softer face contours.',
              '🔲 One-length, flat cuts can create an unbalanced look for various face shapes.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: "How can I pick a hairstyle if I don't know my face shape?",
              answer:
                'Start with universally flattering styles like soft layers, long bobs, or side-swept bangs. These are some of the best hairstyles for different face shapes.'
            },
            {
              question: 'Is there an easy way to find hairstyles that suit me without knowing my face shape?',
              answer:
                'Absolutely! Hairpaca, an AI-powered hairstyle simulator, lets you virtually try on styles and see what looks great—no face shape analysis needed.'
            },
            {
              question: "What are the worst hairstyles if I don't know my face shape?",
              answer:
                'Avoid extreme cuts like ultra-short pixies or super blunt bobs, which can emphasize the wrong angles.'
            },
            {
              question: 'Do certain hairstyles work on most face shapes?',
              answer:
                'Yes! Soft waves, layered cuts, and textured lobs are popular because they complement nearly every face shape.'
            }
          ]
        }
      },
      Longface: {
        steps: {
          'Step 1':
            'Find the widest part of your face: forehead, cheekbones, or jawline. Determine which area stands out most.',
          'Step 2': 'Observe your jawline shape in the mirror: sharp and angular, rounded, or somewhere in between.',
          'Step 3':
            "Visualize the length: is your face longer or shorter than it is wide? Note if it's oval, round, square, or other."
        },
        suggest: {
          well: {
            title: 'Works Well for LongFace',
            tips: [
              '👍 Add volume with layered cuts to balance elongated face shapes.',
              '✨ Curtain bangs soften angles and highlight cheekbones beautifully.',
              '🔍 Try side parting for a flattering asymmetrical look.',
              '💇 Soft waves create fullness and complement long face features.',
              '👒 Long, tapered styles slim sides for best styles for LongFace.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have LongFace',
            tips: [
              '🚫 Steer clear of ultra-short pixie cuts for LongFace compensation.',
              '❌ Avoid tight ponytails that accentuate elongated features.',
              '🙅 Drop blunt, straight cuts; they elongate the appearance.',
              '🛑 Skip heavy center parts that add length without balance.',
              '😣 Say no to high volume top layers; keep balance across the face.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What hairstyles suit a long face best?',
              answer:
                'Opt for hairstyles that add width like layered cuts, waves, and curls, which can balance out a long face shape. Side-swept bangs or chin-length bobs are also flattering styles.'
            },
            {
              question: 'Can a long face pull off bangs well?',
              answer:
                'Absolutely! Bangs can be a great option for long faces. Try blunt or side-swept bangs to create the illusion of a shorter face, adding dimension and interest to your look.'
            },
            {
              question: 'Are there any styles I should avoid with a long face?',
              answer:
                'Avoid styles that add volume on top, like tight ponytails or high buns. These can elongate the face further, making it appear longer than it is. Instead, focus on styles that add width or soften.'
            },
            {
              question: 'How do I choose the right haircut for my long face shape?',
              answer:
                'Consider styles that focus on creating volume on the sides rather than the crown. Layers, wavy textures, and chin-length bobs can help round out a long face shape beautifully.'
            },
            {
              question: 'What hair tips help make a long face look shorter?',
              answer:
                'Opt for face-framing layers and soft waves, which can provide the illusion of a shorter face. Side parts and textured styles will distribute the focus, balancing your long face shape.'
            }
          ]
        }
      },
      Heartface: {
        steps: {
          'Step 1':
            'Stand in front of a mirror and observe the widest part of your face. Oval faces usually have evenly balanced features.',
          'Step 2':
            'Check the forehead width compared to the jawline. Oval faces have a softly rounded forehead wider than the jaw.',
          'Step 3':
            'Look at the length and cheek curves. Oval faces have longer lengths and gentle curves around the cheeks, appearing softer overall.'
        },
        suggest: {
          well: {
            title: 'Works Well for HeartFace',
            tips: [
              '✨ Choose side-swept bangs to soften the sharp angles of your heart face.',
              '💖 Try layered bob cuts for some volume and balance with your heart-shaped face.',
              '🎨 Experiment with loose curls to add fullness around your jawline.',
              '🌟 Opt for a chin-length cut to help balance a wider forehead.',
              '🌀 Consider deep side part styles that accentuate your cheekbones beautifully.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have HeartFace',
            tips: [
              "🚫 Stay away from blunt bangs that accentuate the forehead's width.",
              '🙅‍♀️ Avoid straight or slicked-back hairstyles which highlight the pointy chin.',
              "❌ Skip high ponytails that draw attention to the forehead's peak.",
              "🚷 Avoid center parts that don't flatter the heart face shape.",
              "🔒 Refrain from short pixie cuts that amplify the face's natural proportions too sharply."
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are the best hairstyles for a heart-shaped face?',
              answer:
                'A: Try shoulder-length soft waves or a layered bob. These styles accentuate the cheekbones and soften the chin, which beautifully complements a heart-shaped face. Styles like these can add balance and harmonize facial features effectively.'
            },
            {
              question: 'Q: Can bangs look good on a heart-shaped face?',
              answer:
                'A: Absolutely! Side-swept bangs or curtain bangs are great options for heart-shaped faces. They work well to soften the forehead and balance the strong chin, providing a gentle frame around your features.'
            },
            {
              question: 'Q: How can I style my long hair to complement my heart-shaped face?',
              answer:
                'A: Consider adding layers or gentle curls to your long hair. Layers add movement and body, while curls soften angular features, creating a harmonious appearance for your heart-shaped face without overwhelming it.'
            },
            {
              question: 'Q: Are pixie cuts suitable for heart-shaped faces?',
              answer:
                'A: Yes, pixie cuts can look stunning on heart-shaped faces! Opt for textured layers or longer bangs to add dimension, ensuring balance between the wide forehead and the narrower chin, making the eyes and cheekbones pop.'
            },
            {
              question: 'Q: How can I choose a hairstyle that flatters my heart-shaped face for a night out?',
              answer:
                'A: Go for elegant updos or half-up styles with volume at the roots. This lifts focus off of the chin and accentuates your cheekbones. Adding soft waves or curls will enhance elegance, creating a chic and balanced look.'
            }
          ]
        }
      },
      Roundface: {
        steps: {
          'Step 1':
            'Stand in front of a mirror. Observe the widest points of your face - is it the forehead, cheeks, or jawline?',
          'Step 2':
            "Check your face shape's length. Is your face longer or shorter, or does it appear balanced? Note any prominent angles.",
          'Step 3':
            'Look at your chin. Does it appear rounded, sharply pointed, or more square? This helps define your face shape.'
        },
        suggest: {
          well: {
            title: 'Works Well for RoundFace',
            tips: [
              '👩‍🦰 Side-swept bangs soften corners, best styles for RoundFace.',
              '✂️ Layered cuts add volume around cheeks, creating charming dimension.',
              '🌊 Soft waves frame your face, enhancing its natural roundness beautifully.',
              '✨ Long bobs elongate your face, one of the best styles for RoundFace.',
              '📏 Center-part styles streamline the look, perfect for balanced symmetry.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have RoundFace',
            tips: [
              '🚫 Straight-across bangs emphasize roundness, styles to avoid for RoundFace.',
              '⚠️ Rounded curls accentuate your facial circles, not ideal for RoundFace.',
              '❌ Ultra-short pixie cuts reveal more forehead, avoiding balance.',
              '🚫 Tight, high ponytails draw attention to top, avoid these styles for RoundFace.',
              '🚫 Flat, straight styles accentuate width, not flattering for RoundFace.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are the best hairstyles for a round face to look slimmer?',
              answer:
                'To elongate a round face, try asymmetrical cuts like an angled bob or long layers. Adding volume on the crown can create a slimming effect. Soft waves, high ponytails, and side-parted bangs help balance facial features.'
            },
            {
              question: 'Can round-faced individuals wear short hairstyles?',
              answer:
                'Absolutely! Short hairstyles can suit round faces if styled correctly. Consider a pixie cut with volume on top or a bob with textured layers to add dimension. Side-swept bangs can also enhance the look beautifully.'
            },
            {
              question: 'Do bangs suit round face shapes?',
              answer:
                'Yes, bangs can be flattering for round faces. Opt for side-swept bangs or longer fringe that blends with layers. Wispy or choppy bangs can draw attention away from the roundness and add depth to the hairstyle.'
            },
            {
              question: 'Which hairstyles are not ideal for round face shapes?',
              answer:
                'Avoid blunt cuts or styles that emphasize the widest part of your face, like straight across bangs or round bobs. These can make your face appear fuller; instead, aim for styles that create angles or height.'
            },
            {
              question: 'How can I test different hairstyles for my round face without committing?',
              answer:
                'Try virtual hairstyle apps that let you upload a photo to experiment with different cuts. Consult with a stylist to discuss options that might complement your round face shape without the need for drastic styles.'
            }
          ]
        }
      },
      Squareface: {
        steps: {
          'Step 1':
            'Look in the mirror and observe if your face is longer than it is wide; this indicates an oval face shape.',
          'Step 2':
            'With your face front and center, see if your forehead is wider than your chin; if yes, you have a heart shape.',
          'Step 3':
            'Check for balanced width and length with prominent cheekbones; a round face typically lacks sharp lines and angles.'
        },
        suggest: {
          well: {
            title: 'Works Well for SquareFace',
            tips: [
              '😊 Opt for layered hairstyles; they soften angular jawlines elegantly.',
              '💁‍♀️ Side-swept bangs are among the best styles for SquareFace.',
              '✨ Choose a bob with soft waves to enhance facial harmony.',
              '🌸 Long, loose curls beautifully balance a SquareFace structure.',
              '🌀 Wispy fringe adds softness, making SquareFace features more gentle.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have SquareFace',
            tips: [
              '🚫 Steer clear of blunt bangs; they emphasize the square forehead.',
              '❌ Strictly avoid super short pixie cuts that accentuate angles.',
              '⚠️ Straight, sleek styles can overly define the strong jawline.',
              '🔥 Say no to center partings that elongate the face awkwardly.',
              '⛔ Flat, straight textures weaken the best styles for SquareFace.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What hairstyles best suit square face shapes for women?',
              answer:
                'A: Soft layers and waves can beautifully complement a square face shape. Styles like side-swept bangs or a lob with loose curls soften the angular jawline, enhancing femininity. Include "best hairstyles for square faces" in your search for tailored options.'
            },
            {
              question: 'Q: How can men choose flattering hairstyles for square face shapes?',
              answer:
                'A: Men with square faces should try styles with volume on top, like pompadours or quiffs. These add height and can balance out strong jawlines. Use keywords like "men\'s hairstyles square face" for more inspiration.'
            },
            {
              question: 'Q: Are short hairstyles suitable for a square face shape?',
              answer:
                'A: Absolutely! Pixie cuts with texture or asymmetrical bobs work well as they add dimension. Incorporating "short hairstyles for square face shapes" will yield stylish ideas that enhance your features.'
            },
            {
              question: 'Q: Which long hairstyles complement square face shapes?',
              answer:
                'A: Long, flowing layers with subtle volume can elongate a square face. Try center parting or curtain bangs for a softer look. Searching "long hairstyles for square face shapes" can offer chic and elegant options.'
            },
            {
              question: 'Q: Can bangs enhance a square face shape, and which type should I choose?',
              answer:
                'A: Bangs like curtain bangs or wispy fringe can beautifully frame a square face, adding softness. Avoid blunt cuts. Include "bangs for square face shapes" in your search for specific styling tips.'
            }
          ]
        }
      },
      Ovalface: {
        steps: {
          'Step 1':
            'Stand before a mirror, looking straight ahead. Trace the outline of your face using a washable marker on the mirror.',
          'Step 2':
            'Check if the length matches width symmetrically. If equal, it indicates a round face. Longer than wide suggests an oval face.',
          'Step 3':
            "Observe your jawline: If it's angular or square, you might have a square face; pointed would indicate a heart-shaped face."
        },
        suggest: {
          well: {
            title: 'Works Well for OvalFace',
            tips: [
              '🌟 Rock medium length hair with soft layers and natural waves.',
              "👌 Try center or side parting; they're the best styles for OvalFace.",
              '😍 Embrace beachy waves for added volume and playful texture.',
              '💁‍♀️ Go bold with blunt bob cuts to frame your features beautifully.',
              '🎉 Play with messy buns, perfect styles for OvalFace chic vibes.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have OvalFace',
            tips: [
              '🚫 Steer clear of ultra-short pixie cuts; they might exaggerate roundness.',
              '❌ Avoid heavy bangs as they can overwhelm an OvalFace shape.',
              '🙅‍♀️ Say no to harsh, geometric styles that mask natural face curves.',
              '🙅‍♂️ Skip center parts in sleek styles; they elongate the face too much.',
              '🚫 Avoid overly tight ponytails that pull away from your facial features.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are the best hairstyles for an oval face shape?',
              answer:
                'A: Oval faces suit various styles such as bouncy waves, sleek ponytails, and layered cuts. Long tail keywords like "flattering hairstyles for oval face shape" can guide your search for more ideas.'
            },
            {
              question: 'Q: Can bangs enhance features on an oval face shape?',
              answer:
                'A: Yes! Bangs can highlight your eyes and cheekbones. Consider options like "choppy bangs for oval face" to find a style that complements your features beautifully.'
            },
            {
              question: 'Q: Which haircut length complements an oval face shape?',
              answer:
                'A: Almost any length suits oval faces, but medium lengths are especially versatile. Try "best medium length hairstyles for oval face" to explore styles that enhance your natural grace.'
            },
            {
              question: 'Q: Are there specific updos that flatter an oval face shape?',
              answer:
                'A: Certainly, elegant updos like low buns or sleek top knots accentuate an oval face\'s symmetry. Search for "oval face shape updo styles" to discover chic options for formal occasions.'
            },
            {
              question: 'Q: How does hair texture affect style choices for oval face shapes?',
              answer:
                'A: Hair texture can guide style choices, with textured waves or sleek layers enhancing oval faces. Look up "oval face shape hairstyles by hair texture" to find personalized styling inspirations.'
            }
          ]
        }
      }
    }
  },
  'trending-hairstyles': {
    main_tip: {
      all: 'Trendiest Hairstyles for 2025',
      other: 'Trendiest *** Hairstyles for 2025'
    },
    create_content: {
      title: {
        all: 'How to figure out which hair length suits you?',
        other: 'How to figure out if *** hair is right for you?'
      },
      sub_title: 'Find the ideal hair length for your style with our easy guide.'
    },
    callback: {
      normal: 'Found the perfect hair length for you? Try our *** now to see if this hair length really works for you!',
      link: 'AI hairstyle simulator'
    },
    suggest_title: "Styling Tips for *** Hair: Do's & Don'ts",
    fitChat: {
      title: 'Hair Length & Face Shape Compatibility Chart',
      header: ['Hair Length ↓ / Face Shape →', 'Round', 'Square', 'Oval', 'Heart', 'Long'],
      rows: [
        {
          shape: 'Short',
          values: ['⭐', '✅', '✅', '⚠️', '⚠️']
        },
        {
          shape: 'Medium',
          values: ['✅', '✅', '✅', '✅', '⭐']
        },
        {
          shape: 'Long',
          values: ['⚠️', '⭐', '✅', '✅', '⚠️']
        }
      ],
      tips: [
        '✅ Best match: Very flattering for this face shape',
        '⭐ Good choice: Works well with minor adjustments',
        '⚠️ Use with caution: May require styling to suit this face shape'
      ]
    },
    label_data: {
      All: {
        steps: {
          'Step 1': 'Stand in front of a mirror and observe your face shape—round, oval, square, or heart.',
          'Step 2':
            'Use your fingers to "frame" different hair lengths around your face—see which brings the most balance.',
          'Step 3':
            'Consider your strongest facial feature—choose short to highlight bone structure, medium for balance, long to soften or elongate.'
        },
        suggest: {
          well: {
            title: '✔️ Recommended',
            tips: [
              '🪞 Try layered cuts—they offer flexibility and suit most face shapes and lengths.',
              "✂️ Go for a long bob—great in-between style if you're unsure about short or long.",
              '💁‍♀️ Soft waves add volume and movement, working across all lengths.',
              '🌀 Textured ends help blend styles when transitioning between lengths.',
              '🎯 Mid-length shag styles are low-commitment and work well on different hair types.'
            ]
          },
          avoid: {
            title: '❌ Avoid',
            tips: [
              "🙅‍♀️ Don't choose ultra-blunt cuts—they're less forgiving if you're unsure of your ideal length.",
              "⛔ Avoid extreme asymmetry—it's bold but harder to adjust if length isn't right.",
              "🚫 Skip styles that require daily heat styling if you're still experimenting.",
              '🔪 Steer clear of micro bangs—they pair best with specific lengths.',
              '🛑 Avoid styles needing frequent trims—they can limit flexibility when exploring new lengths.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'How do I know which hair length looks best on me?',
              answer:
                'Try a virtual hairstyle simulator like Hairpaca to test short, medium, or long styles instantly—no risk involved!'
            },
            {
              question: "What's the best hairstyle if I'm unsure about going short or long?",
              answer:
                'A collarbone-length cut or long bob is a versatile, low-risk option that flatters most face shapes.'
            },
            {
              question: 'Can I change hair lengths gradually instead of all at once?',
              answer: 'Yes! Ask for layered or transitional cuts that let you adjust your hairstyle length over time.'
            },
            {
              question: 'What are some low-maintenance styles for indecisive hair length?',
              answer:
                'Medium-length textured cuts, soft waves, or shags require minimal upkeep and work across many lengths.'
            },
            {
              question: 'Do different hair lengths suit different face shapes?',
              answer:
                'Absolutely—short cuts highlight sharp angles, medium balances most features, and long styles soften strong lines.'
            }
          ]
        }
      },
      Medium: {
        steps: {
          'Step 1':
            'Stand in front of the mirror. Check if your face is neither too long nor too round for balanced, versatile styles benefiting from medium-length hair.',
          'Step 2':
            'Observe your jawline. A strong jawline pairs well with medium length; softer lines may need airy layers for a flattering look.',
          'Step 3':
            'Look at your forehead to chin proportions. Medium length enhances harmonious proportions, providing volume while maintaining elegance and balance across facial features.'
        },
        suggest: {
          well: {
            title: 'Works Well for Medium',
            tips: [
              '🧶 Layered cuts add depth, delivering a textured look perfect for medium styles.',
              '💇‍♀️ Beach waves offer a breezy, trendy style suitable for medium hair.',
              '🧢 Choppy bobs with volume bring a fresh, fashionable vibe for medium lengths.',
              '🌟 Tousled pixie cuts enhance easy maintenance and modern appeal for medium.',
              '🎨 Soft balayage creates dynamic color accents ideal for medium waves.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Medium',
            tips: [
              '🙅‍♀️ Flat straight cuts lack dimension and vibrancy for medium styles.',
              '🚫 Tightly pulled hairstyles can damage and flatten medium textures.',
              '🔎 Heavy fringe creates bulk and may overpower medium lengths.',
              '❌ Over-styling products weigh down and eliminate bounce in medium hair.',
              '🏴 Slick-back styles mute natural movement and charm of medium locks.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are popular medium hairstyles for 2023?',
              answer:
                'In 2023, medium hair trends include textured bobs, layered shags, and polished waves. These styles offer versatility and are ideal for enhancing natural hair movement, making them perfect for medium length hair looks.'
            },
            {
              question: 'How can I style my medium hair for a trendy look?',
              answer:
                'Consider adding curtain bangs or wispy layers to your medium-length hair for a fresh and stylish appearance. Use volumizing mousse and create loose waves with a curling iron to achieve a chic finish.'
            },
            {
              question: 'What medium hairstyle suits round faces?',
              answer:
                'For round faces, try a medium-length lob with subtle layers. This helps elongate your face, offering balance and showcasing the trending medium hairstyles 2023 has embraced.'
            },
            {
              question: 'Are medium length hairstyles low maintenance?',
              answer:
                'Yes, medium-length hairstyles such as shoulder-length curls or a straightforward blunt bob are easy to maintain with regular trims and minimal styling, saving time while staying trendy.'
            },
            {
              question: 'How to choose the right medium hair color for trending styles?',
              answer:
                'When choosing a color, consider your skin tone and eye color. Trendy hues like caramel highlights, chocolate browns, or soft balayage add dimension to medium-length hairstyles, making them more vibrant and stylish.'
            }
          ]
        }
      },
      Short: {
        steps: {
          'Step 1':
            'Check your jawline. If your jawline is strong and well-defined, a short length hairstyle will accentuate and enhance its natural structure.',
          'Step 2':
            'Assess your forehead. Short styles often suit individuals with narrow or smaller foreheads, balancing your facial profile without overwhelming your features.',
          'Step 3':
            'Consider your cheekbones. Prominent cheekbones often benefit from the contrast of shorter hair, highlighting their contour for a striking and sophisticated appearance.'
        },
        suggest: {
          well: {
            title: 'Works Well for Short',
            tips: [
              '🔥 Go pixie with light layers for a chic trending look.',
              '🎨 Add bold highlights to your short bob for a pop of vibrance.',
              '🌿 Opt for soft waves to give volume and texture.',
              '🎉 Choose asymmetrical cuts to add dimension and uniqueness.',
              '📷 Texturize with sleek undercuts for a modern and edgy finish.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Short',
            tips: [
              '🚫 Steer clear from heavy bangs which can weigh down your short style.',
              '💡 Avoid tight curls that diminish volume in short haircuts.',
              '❌ Skip blunt cuts if you prefer a softer, more dynamic appearance.',
              '📜 Say no to dense layering that makes short hair appear flat.',
              '🔄 Refrain from extreme color changes that can overwhelm a short style.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'Q: What are some short trendy hairstyles for 2023?',
              answer:
                'A: Short hairstyles in 2023 include playful pixie cuts, chic bob variations, and edgy buzz cuts. Textured crops are very popular, allowing you to rock that effortless, tousled look. Spice up your style with highlights or pastel colors for a current, trendy vibe.'
            },
            {
              question: 'Q: How can I maintain the volume in my short hairstyle?',
              answer:
                'A: To retain volume in short hair, use lightweight volumizing products and dry shampoo for added lift. Blow-drying with a round brush can work wonders. Avoid overuse of heavy conditioners, as they can weigh down your hair and make styling difficult.'
            },
            {
              question: 'Q: Are short hairstyles suitable for all face shapes?',
              answer:
                'A: Absolutely! Short hairstyles can complement any face shape; the key is choosing the right cut. For round faces, opt for asymmetrical bobs or layered pixie cuts. Oval faces can try angled bobs. Consulting your stylist can help find the best short haircut for your face shape.'
            },
            {
              question: 'Q: What are some styling tips for short curly hair?',
              answer:
                'A: Short curly hair can look fantastic when styled right. Use curl-enhancing creams or gels to define your curls and keep frizz at bay. Diffuse your curls gently for volume, and consider regular trims to maintain a shape that complements your unique curl pattern.'
            },
            {
              question: 'Q: How do I transition from long to short hair without regrets?',
              answer:
                'A: Start by trying a mid-length cut before going short. Experiment with styling techniques to see how shorter hair suits your lifestyle. Communicate openly with your stylist about preferences and concerns. Embrace the change, and remember, hair grows back and short hairstyles offer many styling options!'
            }
          ]
        }
      },
      Long: {
        steps: {
          'Step 1':
            'Identify your face shape in the mirror – long hairstyles complement oval, heart, and round faces with a soft, balanced silhouette.',
          'Step 2':
            'Look at your hairline. Long styles suit straight or defined ones, providing volume to create a harmonious look.',
          'Step 3':
            "Check your neck's length. Longer locks accentuate medium to long necks, ensuring the style flows naturally without overwhelming features."
        },
        suggest: {
          well: {
            title: 'Works Well for Long',
            tips: [
              '✨ Layered waves add dimension to long locks, making it a best style for Long.',
              '🌻 Long bob is versatile and chic, perfect as a trending choice for Long hair.',
              '🌀 Loose curls enhance texture and movement, offering a stylish look for Long lengths.',
              '💫 Straight and sleek provides a polished appearance, a top style for Long cuts.',
              '🍃 Braided updos offer elegance and charm, being a fashionable option for Long hair.'
            ]
          },
          avoid: {
            title: 'Avoid If You Have Long',
            tips: [
              '🚫 High ponytails can cause stress on roots; styles to avoid for Long hair.',
              '❌ Constant tight buns risk breakage; not ideal for maintaining Long lengths.',
              '🪞 Over-layering may thin out appearance; not the best style for Long textures.',
              '📛 Excessive teasing damages hair fibers; styles to avoid for healthy Long locks.',
              '🔍 Heavy bangs may weigh down; not suitable for flowy Long styles.'
            ]
          }
        },
        faq: {
          faqs: [
            {
              question: 'What are some trending long hairstyles for women?',
              answer:
                "Popular long hairstyles include beachy waves, sleek straight looks, layered cuts, and soft curls. They're perfect for various occasions and can be styled easily to suit any personal taste. Try mixing it up with balayage or soft highlights for that extra trendy edge."
            },
            {
              question: 'How can I maintain healthy long hair without frequent salon visits?',
              answer:
                'Keep your long locks luscious by using natural oil treatments, regular trims, and sulfate-free shampoos. Protect from heat damage with thermal protectants and embrace silk pillowcases to minimize overnight frizz. These simple home hacks keep your hair vibrant and healthy.'
            },
            {
              question: 'What long hairstyles are best for curly hair?',
              answer:
                'Embrace your naturally curly texture with layered long cuts that enhance volume and movement. Opt for styles like cascading curls and tousled waves. Incorporating lightweight curl creams and diffusing techniques adds definition while maintaining length.'
            },
            {
              question: 'Are long hairstyles suitable for formal events?',
              answer:
                'Absolutely! Elegant updos, sophisticated ponytails, or classic low buns are trending ways to style long hair for formal events. Incorporate braided accents or sparkling hair accessories to elevate the look and wow at any occasion that calls for glam.'
            },
            {
              question: 'How can I add volume to long fine hair?',
              answer:
                'Boost volume in fine long hair by trying layers or feathered cuts that create depth. Use volumizing sprays or mousse at the roots before blow-drying upside down. Incorporating these techniques will create body and fuller appearance without compromising length.'
            }
          ]
        }
      }
    }
  }
};

// 3. 导出获取数据的函数
export const getDataByPathId = (pathId: string) => {
  if (!pathId || !(pathId in landingData)) {
    return null;
  }
  return landingData[pathId];
};
